import * as React from "react";
import { useMemo } from "react";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import SearchExecutionState from "views/logic/search/SearchExecutionState";
import useSearchExecutors from "views/components/contexts/useSearchExecutors";
import { searchExecutionSliceReducer } from "views/logic/slices/searchExecutionSlice";
const useInitialState = (result) => useMemo(
  () => ({
    searchExecution: {
      searchTypesToSearch: void 0,
      executionState: SearchExecutionState.empty(),
      isLoading: false,
      result
    }
  }),
  [result]
);
const createStore = (reducers, initialState, searchExecutors) => {
  const reducer = Object.fromEntries(reducers.map((r) => [r.key, r.reducer]));
  return configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
      thunk: {
        extraArgument: { searchExecutors }
      }
    })
  });
};
const DataLakePreviewStoreProvider = ({ children = void 0, result = void 0 }) => {
  const reducers = useMemo(
    () => [
      {
        key: "searchExecution",
        reducer: searchExecutionSliceReducer
      }
    ],
    []
  );
  const initialState = useInitialState(result);
  const searchExecutors = useSearchExecutors();
  const store = useMemo(
    () => createStore(reducers, initialState, searchExecutors),
    [initialState, reducers, searchExecutors]
  );
  return /* @__PURE__ */ React.createElement(Provider, { store }, children);
};
export default DataLakePreviewStoreProvider;
